import React, { Component } from "react";
import { connect } from 'react-redux';
// import {FormBlocks} from '../FormBlocks';
// import {formFieldsAttributes} from '../../../FormBuilderFunctions/FieldProps';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import {isSet,currencyListUtil,userUtilList,isEmptyValueExist,getSelectedValueBasedOnField,resolveMultiLookupDisplayText} from '../../../../../Utils/CommonFunctions';
import { withRouter } from "react-router";
import $ from 'jquery';
import http from '../../../../../services/http';
import {getUserInfo,getWindowIcons,getProfileAuthorities} from '../../../../../Utils/UserFunctions';
import SingleUserModal from '../UserField/SingleUserModal';
import MultiUserModel from '../UserField/MultiUserModel';
import LookupModal from '../Lookup/LookupModal';
import MultiLookupModal from '../MultiLookup/MultiLookupModal';
import WindowIcons from '../../../../../Components/Icons/WindowIcon';
import Icons from '../../../../../Components/Icons/Icons';
import { LOOKUP_API_FIELD_ID,API_STATUS_SUCCESS,ORGANIZATION_WINDOW_ID,NOTES_WINDOW_ID,CUSTOM_WINDOW_ID,ADDITIONAL_LAYOUT_FIELDS } from '../../../../../Global/Constants';
import { getFieldPropertiesFromGridList } from '../../../../../Containers/LayoutContainer/LayoutCommonFunction';
import {
  addSelectedMultiLookupAction,
  // onChangeInputAction,
  setSelectedMultiLookupAction,
  removeSelectedMultiLookupAction,
  dropDownFieldMappingAction
} from '../../../../../store/actions/formBuilderActions';


class CustomAll extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectOptions:[],
      filterText:'',
      filterOptions:[],
      isSingle:true,
      selectedValue:'',
      clickedOutside: false,
      multiLookupSelectedValue:"",
      multiLookupValueList:null,
      isModalOpen: false,      
      displayName:'',
      lookupIcon:'fas fa-users', 
      componentsListIcon:['User','Lookup','MultiLookup'],
      isQuickAddModalOpen:false,
      lookup_layout:{},  
      tableRecords:{
        tableHead:[],
        tableData:[], 
        pagination:{
          page:0,
          orderBy:'',
          perPage:10,
          direction:'ASC',
          totalRecords:0,
          search:''
        }
      },
      isConfirmPage:false,  
      isModalOpenMulti:false,
      componentName:this.props.item.element_original,
      lookupData:{}
    }    
    this.searchBoxRef = React.createRef();
    this.dropdownMenuRef = React.createRef();
  }
  
  // myRef = React.createRef();
  // handleClickOutside = e => {
  //   if (!this.myRef.current.contains(e.target)) {      
  //     const {item} = this.props;     
  //     $('#subform_'+item.id).hide(250);
  //   }
  // };

  componentWillUnmount = () => { }

  componentWillMount = () => { }

  componentDidMount = () => {
    const {item,fieldObj} = this.props;
    //console.log('componentDidMount item==',item)
    let getSelectedValue = isSet(item.selectedValue,'');
    // getSelectedValue = (isSet(item.selectedValue,null)!==null || item.overridden)?item.selectedValue:(isSet(item.default_value,null)!==null)?item.default_value:'';

    let selectOptions = [];
    if(item.element_original === 'PickList'){
      selectOptions = this.assignOptionListForPickList();      
      this.setState({selectOptions:selectOptions,isSingle:true,selectedValue:getSelectedValue})
    }else if(item.element_original === 'MultiSelect'){
      selectOptions = this.assignOptionList();
      this.setState({selectOptions:selectOptions,isSingle:false,selectedValue:getSelectedValue})
    }else if(item.element_original === 'User'){
      this.LayoutsUsersList();
      setTimeout(() => {        
        try{          
          if(item.selectedValue!==null && item.selectedValue!==''){
            const selectedValueJSON = JSON.parse(item.selectedValue);
            let selectedValue = [];
            let displayName = [];
            let multiUserSelectedValue = [];
            selectedValueJSON.map((data)=>{              
              selectedValue.push(data.id);  
              displayName.push(data.first_name+' '+data.last_name);
              multiUserSelectedValue.push({
                text:data.first_name+' '+data.last_name,
                label:data.first_name+' '+data.last_name,
                id:data.id,
                value:data.id
              })            
            });
            this.setState({selectedValue:selectedValue.join(',')});
            if(item.is_single_user_reference===true){
              this.setLookupValuesFromList({label:displayName.join(''),value:selectedValue.join(',')});
            }else{             
              this.setLookupValuesFromList({label:displayName.join(''),value:selectedValue.join(',')});
            }

          }else{
            const userInfo = getUserInfo();
            let displayName = [];
            displayName.push(userInfo.data.first_name+'' +userInfo.data.last_name);
            this.setState({isSingle:item.is_single_user_reference,selectedValue:userInfo.data.id});
            this.setLookupValuesFromList({label:displayName.join(''),value:userInfo.data.id});
          } 
        }catch(e) {
          console.log(e);
        }
      },200)      
    }else if(item.element_original === 'Lookup'){
      this.LayoutsFormsList('')
      // if(getUserAuthorities()!==null && getUserAuthorities().code===200 && getUserAuthorities().data.length>0){
      //   getUserAuthorities().data.map((winItem,index)=>{
      //     if(winItem.module_name==='CRM'){
      //       winItem.windows.map((window,windowIndex)=>{
      //         if(this.props.item.value===window.window_name){
      //           this.setState({lookupIcon:window.css_property})
      //         }
      //         return true;
      //       });
            
      //     }
      //     return true;
      //   });
      // }
      setTimeout(() => {
        try{
          if(item.selectedValue!==null && item.selectedValue!==''){
            if(item?.displayValue && item?.displayValue!==this.state.displayName){
              this.setState({
                displayName:item?.displayValue,
                selectedValue:item.selectedValue
              })
            }else{
              this.setState({selectedValue:item.selectedValue});
            }
          } 
        }catch(e) {
          console.log(e);
        }  
      },200)
    }else if(item.element_original === 'MultiLookup'){
        this.LayoutsFormsListMulti('',true);
        // if(getUserAuthorities()!==null && getUserAuthorities().code===200 && getUserAuthorities().data.length>0){
        //   getUserAuthorities().data.map((winItem,index)=>{
        //     if(winItem.module_name==='CRM'){
        //       winItem.windows.map((window,windowIndex)=>{
        //         if(this.props.item.value===window.window_name){
        //           this.setState({lookupIcon:window.css_property})
        //         }
        //         return true;
        //       });
              
        //     }
        //     return true;
        //   });
        // }

        setTimeout(() => {
          try{
            if(item.selectedValue!==null && item.selectedValue!==''){
              this.setState({selectedValue:item.selectedValue,isSingle:false,multiLookupSelectedValue:item.selectedValueText});
            } 
          }catch(e) {
            console.log(e);
          }  
        },200)
    }

    
  }

  componentDidUpdate = (prevProps,prevState) => {    
    const {item} = this.props
    //console.log('componentDidUpdate item==',item)
    // const dropdownMenu = this.dropdownMenuRef.current;

    if(prevProps.item!==this.props.item || prevProps.item.selectedValue!==this.props.item.selectedValue){
      let getSelectedValue = '';
      getSelectedValue = isSet(item.selectedValue,null);//(isSet(item.selectedValue,null)!==null || item.overridden)?item.selectedValue:(isSet(item.default_value,null)!==null)?item.default_value:'';
      if(item.element_original === 'PickList'){
        this.setState({selectedValue:getSelectedValue})
      }else if(item.element_original === 'MultiSelect'){
        this.setState({selectedValue:getSelectedValue})
      }else if(item.element_original === 'User'){        
        this.setState({selectedValue:getSelectedValue})         
      }else if(item.element_original === 'Lookup'){    
          if(item?.displayValue && item?.displayValue!==this.state.displayName ){
              this.setState({
                displayName:item?.displayValue,
                selectedValue:getSelectedValue

              })
            }else{
              this.setState({selectedValue:getSelectedValue})         
            }
        //console.log('item.selectedValue==',item.selectedValue) 
      }else if(item.element_original === 'MultiLookup'){       
        //console.log('item.selectedValue==',item.selectedValue) 
        this.setState({selectedValue:getSelectedValue})         
      }
     
    }
    if(prevProps.item.options!==this.props.item.options){
      let selectOptions = [];
      if(item.element_original === 'PickList'){
        selectOptions = this.assignOptionListForPickList(); 
        // console.log('updatedOptions 1',selectOptions);     
        this.setState({selectOptions:selectOptions,filterOptions:selectOptions})
      }
    }
   
  }


  /********** Options settings based on component**************/
  LayoutsFormsListMulti = (value,isDefault=false) => {
    const restrictedFields = ["add", "edit", "clone"]
    const {item} = this.props;    
    if(item.modType==='LAYOUT'){ return false; }
    if(item.is_subform===true){ return false; }// my code 07 - Avoid subform exception
    const params = this.props.match.params;
    const paramsPage = params.page;
    const page = 0;
    const orderBy = ''; 
    const perPage = 10;
    const direction = 'ASC';
    const search = value;
    let API_URL = '';
    let lookupWindowNameId = isSet(this.props.windowID,'');
    let isFromScreen = isSet(this.props.screen,'Layout');
    const queryString1 = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    if((isFromScreen === 'Steps') && (ADDITIONAL_LAYOUT_FIELDS.indexOf(isSet(item.field_name,'')) > -1) && (lookupWindowNameId!=='' && lookupWindowNameId!==null && lookupWindowNameId!==undefined)){
      if(item.field_name === 'Notes'){
        API_URL = LOOKUP_API_FIELD_ID[NOTES_WINDOW_ID]+queryString1;
        API_URL = API_URL.replace('{WINDOW_ID}', lookupWindowNameId);
        http.GET(API_URL)
        .then(response => {
            const responseData = response.data;
            if(responseData.code === API_STATUS_SUCCESS) {
              let datalist = [];//ORGANIZATION_WINDOW_ID === lookupWindowNameId ? responseData.data.organization_list.content : responseData.data.content;
              if(ORGANIZATION_WINDOW_ID === lookupWindowNameId) {
                if(responseData.data.organization_list.content) {
                  datalist = responseData.data.organization_list.content;
                }
              }else if(responseData.data && responseData.data.content) {
                datalist = responseData.data.content;
              }else if(CUSTOM_WINDOW_ID === lookupWindowNameId) {
                if(responseData.data.windows.content) {
                  datalist = responseData.data.windows.content;
                }
              }
              let updateTableData = [];
              if(datalist.length > 0) {
              
                datalist.map((arr,i) => {
                  let value = '';
                  if(item.field_name === 'Notes') {
                    value = {
                            label:arr.note_content ? arr.note_content.substring(0, 20) : '',
                            text:arr.note_content ? arr.note_content.substring(0, 20) : '',
                            value:arr.id,
                            id:arr.id
                          }
                  }
                  
                  updateTableData.push(value);
                })
              }
              if(updateTableData && updateTableData.length > 0) {
                  this.setState({selectOptions: updateTableData}); 
                }else {
                  updateTableData.push({
                      text:'No records found',
                      id:'',
                      value:'',
                      label:'No records found'
                  });
                  this.setState({selectOptions: updateTableData});
                }
            }else {
              this.setState({selectOptions:[{
                      text:'No records found',
                      id:'',
                      value:'',
                      label:'No records found'
                  }]});
            }
          }, (error) => {
              console.log(error);
              this.setState({selectOptions:[{
                      text:'No records found',
                      id:'',
                      value:'',
                      label:'No records found'
                  }]});
          }) 
      }
    }else{
      const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction+'&parent_layout_id='+params.layoutId+'&parent_window_id='+params.windowId;
      if (!restrictedFields.includes(paramsPage.toLowerCase())) {
        API_URL = 'table-data-engine/' + item.value + '/metatable/record-list/active' + queryString;
      } else {
        API_URL = 'table-data-engine/' + item.value + '/metatable/record-list' + queryString;
      }
       http.POST(API_URL,{})
        .then(res => {
          if(res.status===200){ 
            const response = res.data;
            if(response.code===200){              
              let updateTableData = [];
              let fieldsRow = [];
              let fieldsRowData;
              let defaultDisFieldsRow = [];
              this.setState({lookup_layout:{
                lookupLayoutId:response.data.lookup_layout_id,
                moduleId:response.data.module_id,
                windowId:response.data.window_id,
                windowName:this.props.item.value
              }});
              let tablehead = [
                {
                  name:'',
                  type:"Checkbox",
                  columnName:"",
                  isShow:true,
                  attributes:{style:{width: "30px"}}
                }
              ]
              const headAction = {
                header:{
                  checked:true,
                  name:'windowCheckbox',
                  isShow:true,
                },
                headerKey:'Checkbox'
              }
              response.data.grid_list.map((header)=>{
                tablehead.push({
                  name:header.display_name,
                  type:"HyperLink",
                  columnId:header.table_descriptor_id,
                  isShow:header.is_show,
                });
              }) 
              
              const gridList = response.data.grid_list;
              const layout_rule_map = isSet(response.data.layout_rule_map,{});
                  response.data.value_list.content.map((contentData)=>{
                    fieldsRow = [];
                    let fieldsRowData  = {};
                    defaultDisFieldsRow = [];
                    fieldsRowData = {
                      ...fieldsRowData,
                      [headAction.headerKey]:{...headAction.header}
                    };
                    tablehead.map((column,headIndex)=>{
                      if(headIndex>0){
                        fieldsRowData = {
                          ...fieldsRowData,
                          [column.columnId]:{
                            className:'',
                            value:''
                          },
                        } 
                      }
                    });
                  contentData.fields.map((item,itemIndex)=>{
                    tablehead = [...tablehead].map((column)=>{
                      if(item.table_descriptor_id===column.columnId){
                        let dataType = '';
                        if(item.element_type === 'Barcode') {
                          dataType = 'Barcode';
                        }else if(item.element_type==='Image' && item.files.length===0) {
                          dataType = 'Image';
                        }else if(item.element_type==='CheckBoxes') {
                          dataType = 'Others';
                        }else if(item.element_type!=='Image') {
                          dataType = 'HyperLink';
                        }else {
                          dataType = 'Image';
                        }
                        column.type = dataType;
                      }
                      return column;
                    });
                    item.selectedValue = item.value;
                    item.element = (item.element_type==='PickList' || item.element_type==='MultiSelect' || item.element_type==='File'  || (item.element_type==='Image' && item.files.length===0))?'TextInput':item.element_type;
                    item.options = [];
                    const selectedValue = getSelectedValueBasedOnField(item);
                    const displayText = resolveMultiLookupDisplayText(selectedValue);
                    if(displayText!=='' && displayText!=='-'){
                      fieldsRowData = {
                        ...fieldsRowData,
                        [item.table_descriptor_id]:{
                              className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
                              isDefaultDisplay:isSet(item.is_default_displayname,false),
                              value:selectedValue,
                              label:item.label,
                        }
                      }
                        const apiFieldName = item.api_custom_field_name || item.api_field_name;
                        if(apiFieldName==='is_active'){ return; }
                        fieldsRow.push(displayText);
                        const property  = getFieldPropertiesFromGridList(gridList,item.table_descriptor_id);
                        if(isSet(item.is_default_displayname,false)===true || isSet(property.is_default_displayname,false)===true){
                          defaultDisFieldsRow.push(displayText);
                        }
                      }
                });
                const endPos = (fieldsRow.length<=2)? fieldsRow.length:3;
                fieldsRow = (defaultDisFieldsRow.length===0)?fieldsRow.slice(0,endPos):defaultDisFieldsRow;
                const meta_table_id = (contentData.metaTableId)?contentData.metaTableId:contentData.meta_table_id
                updateTableData.push({
                  label:fieldsRow.join(' '),
                  data:{
                    clickHandler:this.onChangeSelectLookup.bind(this,contentData.meta_table_id),
                    className:"selected",
                    isSelected:true,
                    rowId:contentData.meta_table_id,
                    data:fieldsRowData
                  },
                  value:contentData.meta_table_id,
                  id:contentData.meta_table_id,
                  ruleMapping:isSet(layout_rule_map[contentData.meta_table_id],{}),
                  text:fieldsRow.join(' '),
                });
              });
              this.setState({selectOptions:updateTableData,isSingle:false,multiLookupValueList:response.data.value_list.content});
            }else{
              this.setState({selectOptions:[],isSingle:false});
            }
          }
        })
    }  
  }

  LayoutsFormsList = (value) => {
    if(this.props.item.modType==='LAYOUT'){ return false; }
    if(this.props.item.is_subform===true){ return false; } // my code 07 - Avoid subform exception
    const restrictedFields = ["add", "edit", "clone"];
    const params = this.props.match.params;
    const paramsPage = params.page;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 10;//pagination.perPage; 
    const direction = 'ASC';//pagination.direction; 
    const search = value;
    // parent_layout_id:params.layoutId,
    // parent_window_id:params.windowId,
    let API_URL = '';
    const queryString = '?query='+encodeURIComponent(search)+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction+'&parent_layout_id='+params.layoutId+'&parent_window_id='+params.windowId;
    if (!restrictedFields.includes(paramsPage.toLowerCase())) {
      API_URL = 'table-data-engine/' + this.props.item.value + '/metatable/dropdown-list/active' + queryString
    } else {
      API_URL = 'table-data-engine/' + this.props.item.value + '/metatable/dropdown-list' + queryString
    }
    //console.log('API_URL==',API_URL)
    let selectOptions = []
    http.GET(API_URL)
    .then(res => {
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
          let updateTableData = [];
          let fieldsRow;
          let defaultDisFieldsRow;
          let gridList = response.data.grid_list;
          const layout_rule_map = isSet(response.data.layout_rule_map,{});
          const lookupData = isSet(response.data.lookup_data,{});
          
          // console.log('response.data.value_list.content',response.data.value_list.content);
          response.data.value_list.content.map((contentData,contentIndex)=>{
            if(this.props.layoutObject.meta_table_id!==contentData.id){            
            fieldsRow = [];
            let fieldsTableRow  = {};
            defaultDisFieldsRow = [];

            fieldsTableRow = {
              ...fieldsTableRow,
              [contentData.id]:{
                isDefaultDisplay:false,//item.is_default_displayname,
                value:contentData.dpnm
              }
            }
            fieldsRow.push(contentData.dpnm);
            defaultDisFieldsRow.push(contentData.dpnm);
             
            const endPos = (fieldsRow.length<=2)? fieldsRow.length:2;
            fieldsRow = (defaultDisFieldsRow.length===0)?fieldsRow.slice(0,endPos):defaultDisFieldsRow;            
            if(fieldsRow.length>0){
              selectOptions.push({
                label:fieldsRow.join(' '),
                value:contentData.id,
                id:contentData.id,
                ruleMapping:isSet(layout_rule_map[contentData.id],{}),
                fields:fieldsTableRow
              });
            }
          }
        })
        
        let filteredOptions = this.filterByValue(selectOptions,this.state.filterText);   
        this.setState({selectOptions:selectOptions,filterOptions:filteredOptions,isSingle:true,lookupData:lookupData});
        }else{
          let filteredOptions = this.filterByValue(selectOptions,this.state.filterText);   
          this.setState({selectOptions:selectOptions,filterOptions:filteredOptions,isSingle:true});
        }
      }
    })
    .catch(err => {     
    })
  }
  setLookupDataHandler = (data)=>{
    this.setState({
      lookupData:{...this.state.lookupData,...data}
    });
  }

  LayoutsUsersList = (value) => {
    const {item} = this.props;
    let selectOptions = [];
    const windowName = this.props.windowName;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    let perPage = 10;//pagination.perPage'
    if(value===undefined || value === ''){
      perPage = 0;
    }  
    const direction = 'ASC';//pagination.direction; 
    const search = '';
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    http.GET('users/fetch-users/active'+queryString)
    .then(res => {
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){                   
          response.data.content.map((item)=>{
            selectOptions.push({
              label:item.first_name+' '+item.last_name,
              value:item.id,
              id:item.id,
              //text:item.first_name+' '+item.last_name
            });
          })
          this.setState({selectOptions:selectOptions,isSingle:item.is_single_user_reference,lookupIcon:'fas fa-users'})          
          // console.log(selectOptions);          
        }else{  
          this.setState({selectOptions:selectOptions,isSingle:item.is_single_user_reference,lookupIcon:'fas fa-users'})        
        }
      }
    })      
  }

  assignOptionListForPickList = () => {
    const {item} = this.props;
    let selectOptions = [{label:'-None-',value:''}];
    const options = item.options;
    try{
      if(item.picklist_type==='CURRENCY'){
        const currencyList =  currencyListUtil();
        currencyList.map((currency)=>{
          selectOptions.push({
              label:currency.value,
              value:currency.key,
              id:currency.key
          });
        });
      }else if(item.picklist_type==='COUNTRY'){
        const countryList =  (userUtilList().country_list!==undefined && userUtilList().country_list!==null)?userUtilList().country_list:{};
        Object.keys(countryList).forEach(function(key) {
          selectOptions.push({
            id: key,
            value: key,
            label: countryList[key],
          })
        })
      }else{
        selectOptions = options.map((item,index)=>{
          return(
            {
              label:item.value,
              value:item.id,
              id:item.id,
            }
          )
        })
      }
      if(isEmptyValueExist(selectOptions) === false) {
        selectOptions.unshift({label:'-None-',value:''});
      }
      // setOptionsState(selectOptions);
    }catch(e){

    }
    return selectOptions; 
  }

  assignOptionList = () => {
    const {item} = this.props;
    let selectOptions = [{label:'-None-',value:''}];
    const options = item.options;
    try{
      selectOptions = options.map((item,index)=>{
        return(
          {
            label:item.value,
            value:item.id,
            id:item.id,
          }
        )
      })
    }catch(e){

    }
    return selectOptions;
  }
  /********** Options settings based on component**************/




  /************* General method new *****************/

  cardBoxToogle = async (id)=>{
    //console.log('cardBoxToogle==',id)
    //$(".hidden-cnt").hide(250);  
    if (false == $('#'+id).is(':visible')) {
      $('#'+id).show(250);
    }else {
      $('#'+id).hide(250);
    }    
  }

  searchHandler = (e) => {    
    const{selectOptions,filterOptions} = this.state;
    const value = e.target.value;
    if(this.props.item.element_original==="Lookup"){
      this.LayoutsFormsList(value);
      this.setState({filterText:value});
    }else{
       let filteredOptions = this.filterByValue(selectOptions,value);    
      this.setState({filterText:value,filterOptions:filteredOptions});
    }
   
    
   
  }

  filterByValue = (array, string) => {
    return array.filter(o =>
      Object.keys(o).some(k => o[k].toString().toLowerCase().includes(string.toString().toLowerCase()))
    );
  }

  removeHandler = (opt,selArr) => {
    //console.log('removeHandler==',opt,selArr)
    // $(".removeNotHide").on("click", ".dropdown-menu.customHide", function(e){
    //   e.stopPropagation();
    // });
    const  {
      // type,
      item,
      // className,
      // validationForms,
      fieldObj
    } = this.props;
    const {isSingle} = this.state;
    let fArr = []
    fArr = selArr.filter((item)=>item.value!== opt.value);
    if(item.element_original==="MultiLookup"){
      this.checkAndUpdateMultiLookupValue(fArr);
    }
    //console.log('fArr==',fArr)
    //this.props.onChangeInputAction(fieldObj,selArr,item.element_original)
    this.props.onChangeInputAction(fieldObj,fArr,'CustomAllArray')
    
  }

  changeHandler = (opt) => {    
    const  {
      // type,
      item,
      // className,
      // validationForms,
      fieldObj
    } = this.props; 
    const {value} = opt;
    const {lookupData} =  this.state;
    const {selectOptions,isSingle,selectedValue} = this.state;  
    let selectedLookup = this.getLookupRecordData(lookupData,value);
    let updatedFieldObj = {...fieldObj,formType:this.props.formType,lookupData:selectedLookup,label:opt?.label};
    //this.cardBoxToogle('subform_'+item.id) 
    //console.log('changeHandler==',item);
    
    let eVal = ''
    let eValArr = [];
    if(isSingle === true){
      eVal = opt.value;
    }else if(isSingle === false){ //(item.element_original === 'MultiSelect'){
      let value = selectedValue;
      //let defaultValueOptions = [];
      selectOptions.map((item)=>{
          if(isSet(value,'').split(',').indexOf(item.value)!== -1 || isSet(value,'').split(',').indexOf(item.id)!== -1){ 
            item.checked=true;
            eValArr.push(item);
          }
      }) 

      if(eValArr.findIndex(item => item.value === opt.value)===-1){
        eValArr.push(opt);  
      }      
      eVal = eValArr;
    }
    // console.log('eVal==',updatedFieldObj)
    if(isSingle === true){
      this.props.onChangeInputAction(updatedFieldObj,eVal,'CustomAllSingle');
      // console.log('fieldObj',this.props,fieldObj);
      if(item.element_original==="PickList"){
        let isMappingExist = false,isMappingNotNull = false,addedDependency = null;
        this.setState({filterText:'',filterOptions:[]});
        const itemOption = (item.unFilterOption)?item.unFilterOption:item.options;
        itemOption.map((option,index)=>{
            if(option.dependency_map && option.dependency_map!==null){
            isMappingExist = true;
            const dependencyMap = option.dependency_map;
            addedDependency  = dependencyMap;
            if(option.id===value){
              isMappingNotNull = true;
              this.props.dropDownFieldMappingAction(updatedFieldObj,dependencyMap);
            }
            }
        })
        if(isMappingNotNull===false && isMappingExist===true){
          this.props.dropDownFieldMappingAction({...updatedFieldObj,dependencyNull:true},addedDependency);
        }
      }
      
    }else{
      if(item.element_original==="MultiLookup"){
        this.checkAndUpdateMultiLookupValue(eVal);
      }
      this.props.onChangeInputAction(updatedFieldObj,eVal,'CustomAllArray')
    }
    
  }
    //check and update multilookup selectedvalue
    checkAndUpdateMultiLookupValue = (res)=>{
      const {multiLookupValueList} = this.state;
      let selectedValueIds = [];
      let updatedSelectedValue = [];
      if(multiLookupValueList!=null){
        res.map((item)=>{
          if(item.id!==undefined){
            selectedValueIds.push(item.id);
          }else if(item.rowId!==undefined && item.isSelected ){
            selectedValueIds.push(item.rowId);
          }
          
        });
        if(selectedValueIds.length>0){
          multiLookupValueList.map((value)=>{
            if(selectedValueIds.indexOf(value.meta_table_id)!==-1)
            updatedSelectedValue.push(value);
          })
        }
      }
      this.setState({
        multiLookupSelectedValue:(updatedSelectedValue.length>0)?JSON.stringify(updatedSelectedValue):""
      })
    }

  /************* General method new *****************/
  toggleDropdown = () => {
    // Start the interval when the dropdown toggle is clicked
    console.log('Dropdown is shown check..')
    this.checkDropdownInterval = setInterval(() => {
      const dropdownMenu = this.dropdownMenuRef.current;
      if (dropdownMenu && dropdownMenu.classList.contains('show')) {
        // Dropdown is shown, clear the interval
        clearInterval(this.checkDropdownInterval);
        console.log('Dropdown is shown');
      }
    }, 100); // Check every 100ms
  };

  render(){
    const  {
      type,
      item,
      className,
      validationForms,
      fieldObj
    } = this.props;
    // const attr = formFieldsAttributes(
    //   {...item,className:className},
    //   validationForms
    // );     
    const {selectOptions,filterText,filterOptions,isSingle,selectedValue,componentsListIcon,isModalOpen,isModalOpenMulti,componentName} = this.state;
    // console.log('selectOptions==',this.props.item.options);

    let isComponentIcon = false;
    if(componentsListIcon.findIndex(comp => comp === item.element_original)!==-1){
      isComponentIcon = true;
    }


    let optionsList = selectOptions;
    if(filterText !== ''){
      optionsList = filterOptions;
    }
    
    let getSelectedOpt = selectedValue;
    //console.log('attr.value',attr.value);
    let getSelectedOptArr = [];
    if(isSingle===true){ //(item.element_original === 'PickList'){
      getSelectedOpt = selectOptions.find(e => e.value === selectedValue);
    }else{
      selectOptions.map((item)=>{
          if(selectedValue.split(',').indexOf(item.value)!== -1 || selectedValue.split(',').indexOf(item.id)!== -1){ 
            item.checked=true;
            getSelectedOptArr.push(item);
          }
      })
    }
    if(getSelectedOpt==undefined){
      getSelectedOpt={label:''};
    }

    const WindowProfile = getProfileAuthorities();
    const svgIcons =getWindowIcons();
    let windowIcon ="";
    let isSystemIcon=true;
    let htmlCode ='';
    let sourceImage=''; 
    WindowProfile.data.windows.map((window) => {
      if(window.window_name===item.value & window.window_icon!==undefined ){
        windowIcon=window.window_icon;
        isSystemIcon=window.is_system_icon;
        if(window.is_system_icon===false){ 
          svgIcons.map((svg,i)=>{
            if(svg.id===window.window_icon){
              htmlCode=svg.icon_name;
              sourceImage = 'data:image/svg+xml;base64,'+svg.svg_icon;  
            }

          });
        }
      }
    })
    
    return(
      <Wrp>
        {/*<div ref={this.myRef}> onClick={this.cardBoxToogle.bind(this,'subform_'+item.id)}*/}
        <div className="input-group position-static">

          <div className="customized-control">
            <div className="componenetInner text-truncate w-100">
              {
                (isSingle === true)?
                isSet(getSelectedOpt)?isSet(getSelectedOpt.label,this.state.displayName):isSet(selectedValue,this.state.displayName)
                :
                isSet(getSelectedOptArr,[]).map((opt,index)=>{
                  return(
                    <>
                      <div className="tagsInner badge badge-info removeNotHide" key={index} title={isSet(getSelectedOptArr,[]).map(obj => obj.label).join(',')}>
                        <span className="text-truncate multiSelectTag" title={opt.label}>{opt.label}</span> 
                        <span data-role="remove" onClick={this.removeHandler.bind(this,opt,getSelectedOptArr)}></span>
                      </div>
                    </>
                  )
                })
              }
            </div>  
            <span className="custom-select cursor-pointer" data-toggle="dropdown"></span> 
          
            <div ref={this.dropdownMenuRef} className="dropdown-menu dropdown-menu-right customHide animated fadeIn" id={`subform_${item.id}`} style={{"width":"265px","paddingTop":"0px"}}>  
              <div className="clearfix"> 
                <div className="card-header p-2 border-0">
                  <input type="text" id="" ref={this.searchBoxRef} className="form-control form-control-sm"  style={{width:'100%'}} value={filterText} onChange={(e)=>this.searchHandler(e)} placeholder="Search here...." />
                </div>
                <div className="card-body p-0 fixedHeight">
                  <div className="card-list">
                    {
                      optionsList.map((opt,index)=>{ 
                        let isSelected = '';
                        if(isSingle === true){
                          if(opt.value===selectedValue){
                            isSelected = 'option-selected';
                          }  
                        }

                        if(isSingle === false){
                          let getSelectedVal = selectedValue.split(',');
                          //console.log('getSelectedVal==',getSelectedVal)
                          if(getSelectedVal.findIndex(item=>item === opt.value)!==-1){
                            isSelected = 'option-selected';
                          }  
                        }

                        return(
                          <>
                            <a className={`cursor-pointer dropdown-item ${isSelected}`} onClick={()=>this.changeHandler(opt)}>       
                              <span className="text-truncate d-block" >{opt.label}</span>
                            </a>                              
                          </>
                        )
                      })
                    }                                          
                  </div>
                </div>
              </div>
            </div> 
          </div>

          {
            isComponentIcon === true?
            <>
              {
                isSingle === true?
                <div className={(item.required===true)? "input-group-append cursor-pointer mandatory":"input-group-append cursor-pointer"} onClick={()=>(item.modType!=='QUICKFORM')?this.openLoopupModalHandler():{}}>
                  <span className="input-group-text">
                    {

                      (componentName === 'User')?
                      <i className={this.state.lookupIcon}></i>
                      :
                      isSet(windowIcon,null)!==null?
                      (!isSystemIcon?<img src={sourceImage}  width='16' height='16' />:<WindowIcons size={16} color = {'#000'}windowIcon={windowIcon}/>)
                      :
                     <Icons iconType={item.value} size={16} color={'#000'}/>
                    }
                  </span>  
                </div>
                :
                <div className={(item.required===true)? "input-group-append cursor-pointer mandatory":"input-group-append cursor-pointer"} onClick={()=>(item.modType!=='QUICKFORM')?this.openMultiLoopupModalHandler():{}}>
                  <span className="input-group-text">
                    {
                      (componentName === 'User')?
                      <i className={this.state.lookupIcon}></i>
                      :
                      isSet(windowIcon,null)!==null?
                      (!isSystemIcon?<img src={sourceImage}  width='16' height='16' />:<WindowIcons size={16} color = {'#000'}windowIcon={windowIcon}/>)
                      :
                      <Icons iconType={item.value} size={16} color={'#000'}/>
                    }
                  </span>  
                </div>
                
              }
              
            </>
            :
            null 
          }
          

        </div>


        {
          (item.element_original === 'User')?
          (item.is_single_user_reference)?
            <SingleUserModal 
            {...this.props}
            item={item}
            isModalOpen={this.state.isModalOpen} 
            windowName={item.value}
            selectedValue={selectedValue}
            cancelLoopupModalHandler={this.cancelLoopupModalHandler} 
            setLookupValuesFromList={this.setLookupValuesFromList}
            lookup_layout=""
            />:
            <MultiUserModel
            {...this.props} 
            item={item}
            isModalOpen={this.state.isModalOpenMulti} 
            windowName={item.value}
            selectedValue={selectedValue}
            cancelLoopupModalHandler={this.cancelMultiLoopupModalHandler} 
            multipleUserDisplayName=""
            setMultiLookupValuesFromList={this.setMultiLookupValuesFromList}
            lookup_layout=""
            />
          :
          <></>          
        }

        {
          (item.modType!=='LAYOUT' && item.element_original === 'Lookup')?
          <LookupModal 
          {...this.props}
          item={item}
          isModalOpen={this.state.isModalOpen} 
          windowName={item.value}
          selectedValue={selectedValue}
          isQuickAddModalOpen={this.state.isQuickAddModalOpen}
          cancelLoopupModalHandler={this.cancelLoopupModalHandler}            
          setLookupValuesFromList={this.setLookupValuesFromList}
          lookup_layout={this.state.lookup_layout}
          closeQuickCreatePopupFromSugg={this.closeQuickCreatePopupFromSugg}
          setLookupDataHandler={this.setLookupDataHandler}
          />
          :
          ''
        } 

        {
          (item.modType!=='LAYOUT' && item.element_original === 'MultiLookup' && this.state.isModalOpenMulti)?
          <MultiLookupModal 
              item={item} 
              {...this.props}
              isModalOpen={this.state.isModalOpenMulti} 
              windowName={item.value}
              selectedValue={this.state.multiLookupSelectedValue}
              updateInHidden={true}
              tableRecords={this.state.tableRecords}
              isConfirmPage={this.state.isConfirmPage}
              onChangeSelectLookup={this.onChangeSelectLookup}
              updateTableRecords={this.updateTableRecords}
              updateConfirmState={this.updateConfirmState}
              updateSuggestionLookup={this.updateSuggestionLookup}
              cancelMultiLoopupModalHandler={this.cancelMultiLoopupModalHandler} 
              setMultiLookupValuesFromList={this.setMultiLookupValuesFromList}
            />
          : ''
        }

       {/* </div>*/}       
      </Wrp>
    )
  }

  /*************Existing component method **************/

  //MODAL POPUP FOR ADD NEW - OPEN
  openLoopupModalHandler = (isSingleUser) =>{
    // if(isSingleUser){
    //   this.setState({isModalOpen:true,MultiUserModalOpen:false});
    // }else{
    //   this.setState({isModalOpen:false,MultiUserModalOpen:true});
    // }
    this.setState({isModalOpen:true});
  }
  //MODAL POPUP - CANCEL
  cancelLoopupModalHandler = () =>{
    this.setState({isModalOpen: false});
  }

  setLookupValuesFromList = (res) => {
    // console.log('setLookupValuesFromList==',res)
    const  { fieldObj } = this.props; 
    const {selectOptions,isSingle,selectedValue,lookupData} = this.state;
    let selectedLookupData  = this.getLookupRecordData(lookupData,res.value);
    let updatedFieldObj = {...fieldObj,LookupData : selectedLookupData , label:res.label};
    this.setState({displayName:res.label});
    this.props.onChangeInputAction(updatedFieldObj,res.value,'CustomAllSingle')    
  }
  //Get lookupData based on selected record
  getLookupRecordData = (lookupDataList,selectedRecord) =>{
    let lookupData = {};
    if(selectedRecord!==undefined && selectedRecord !== ""){
      Object.entries(lookupDataList).map(([key, Data]) => {
        if(key === selectedRecord){
          lookupData =  Data;
        }
      });
    }
    return lookupData;
  }
  

  setMultiLookupValuesFromList = (res) => {
    //console.log('setMultiLookupValuesFromList==',res)
    const  { fieldObj } = this.props; 
    const {selectOptions,isSingle,selectedValue} = this.state;
    let value = res.value;    
    let eValArr = [];
    selectOptions.map((item)=>{
        if(isSet(value,'').split(',').indexOf(item.value)!== -1 || isSet(value,'').split(',').indexOf(item.id)!== -1){ 
          item.checked=true;
          eValArr.push(item);
        }
    }) 
    this.props.onChangeInputAction(fieldObj,eValArr,'CustomAllArray') 
  }

  closeQuickCreatePopupFromSugg = ()=>{
    this.setState({isQuickAddModalOpen:false});
    this.LayoutsFormsList('');
  }

  onChangeSelectLookup = (rowId,wthis,isFromState=0)=>{
    const tableDataSel = this.state.tableRecords;
    if(isSet(tableDataSel.tableHead[0].checked===true,false)===true){
      tableDataSel.tableHead[0].checked=false;
    }
    tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          const tableData = tableDataSel.tableData.data[index].data;
          let validation = [];
          Object.entries(tableData).map(([key, column]) => {
            if(Object.keys(isSet(column.item,{})).length>0){
              if(isSet(column.item.selectedValue,null)===null){
                validation.push(column.item.label.blocks[0].text+' must be required');
              }
            }
          })
          if(validation.length>0){
            this.props.failMessage(validation.join('</br>'));
            return false;
          }
          const columnId = tableDataSel.tableHead[1].columnName;
          let isChecked;
          isChecked = tableDataSel.tableData.data[index].data.Checkbox.checked;
          tableDataSel.tableData.data[index].className=(isChecked)? '':'selected';
          tableDataSel.tableData.data[index].isSelected=(isChecked)? false:true;
          tableDataSel.tableData.data[index].data.Checkbox.checked=(isChecked)? false:true;

          if(tableDataSel.tableData.data[index].data.Checkbox.checked){
              //Add Redux state for selected Multilook rows
            // console.log('tableDataSel.tableData.data[index]',tableDataSel.tableData.data[index]);
            this.props.addSelectedMultiLookupAction(tableDataSel.tableData.data[index],this.props.item.id);
          }else{
              //Remove Redux state for selected Multilook rows
            this.props.removeSelectedMultiLookupAction(tableDataSel.tableData.data[index].rowId,this.props.item.id);
          }
        }
    });
    this.checkAndUpdateMultiLookupValue(tableDataSel.tableData.data);
    this.updateTableRecords(tableDataSel);
  }

  updateTableRecords = (updateRecords)=>{
    this.setState({tableRecords:{
      ...updateRecords
    }})
  }
  updateConfirmState = (bool)=>{
    this.setState({isConfirmPage:bool})
  }

  updateSuggestionLookup = async (multiLookupData,isAuto=false)=>{
    const {item,itemIndex} = this.props;
    // console.log('multiLookupData',multiLookupData);
    let selectedIds = [];
    let displayNames = [];
    let tableRowData = [];
    let relatedWindowFields = [];
    let rulesMapping = [];
    multiLookupData.map((selectedLookup)=>{
      selectedIds.push(selectedLookup.value);
      tableRowData.push(selectedLookup.data);
      displayNames.push(selectedLookup.label);
      rulesMapping.push(selectedLookup.ruleMapping);
      relatedWindowFields.push(selectedLookup.related_window_fields);
    });
    if(isAuto===true){
       this.updateConfirmState(true);
    }

    await this.props.setSelectedMultiLookupAction(tableRowData,item.id);
    await this.setMultiLookupValuesFromList({
      value:selectedIds.join(','),
      label:displayNames.join(','),
      ruleMapping:rulesMapping,
      stateValue:multiLookupData,
      related_window_fields:isSet(relatedWindowFields,null)});
    this.setState({
      multiLookupData:multiLookupData
    });
  }

  cancelMultiLoopupModalHandler = () =>{
    this.setState({isModalOpenMulti: false});
  }

  //MODAL POPUP FOR ADD NEW - OPEN
   openMultiLoopupModalHandler = () =>{
     if(this.props.item.modType!=='LAYOUT'){
      //this.props.clearSelectedMultiLookup();
     }
    this.setState({isModalOpenMulti:true});
    // console.log(this.state);
  }

  /*************Existing component method **************/

}

CustomAll.defaultProps = {
  className: "form-control",
}



const mapDispatchToProps = dispatch => {
  return {
    addSelectedMultiLookupAction:(data,id)=>dispatch(addSelectedMultiLookupAction(data,id)),
    removeSelectedMultiLookupAction:(data,id)=>dispatch(removeSelectedMultiLookupAction(data,id)),
    setSelectedMultiLookupAction:(data,id)=>dispatch(setSelectedMultiLookupAction(data,id)),
    dropDownFieldMappingAction:(obj,val)=>dispatch(dropDownFieldMappingAction(obj,val)),
    // onChangeInputAction:(data,e,type)=>dispatch(onChangeInputAction(data,e,type))
  };
}
const mapStateToProps = (state,props) => { 
  return {
    selectedMultiLookup : state.formBuilder.selectedMultiLookup,
    layoutObject:state.formBuilder.layoutObject['ADDFORM'],
  };
}
export default
  connect(
    mapStateToProps, 
    mapDispatchToProps
  )(withRouter(CustomAll));


